import "./RestrictedAccess.scss";
import RestrictedAccess from "@mwPages/restriced-access/RestrictedAccess";

export default RestrictedAccess;

